import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export abstract class TabCanceler {

  constructor(protected readonly url: URL) {}

  abstract mustBeCanceled(): boolean;

}
